import React from 'react';
import MypagFaqContainer from 'containers/MypagFaqContainer/MypagFaqContainer';

export default function MypagFaqPage() {
    return (
        <MypagFaqContainer />
    )
}
